<div class="pr-table">
    <div class="pr-table-header">
        <app-column-header *ngFor="let column of tableColumnsLabels"
                           [label]="column.label"
                           [columnId]="column.propertyToSort"
                           [defaultState]="column.defaultState"
                           (sortBtnClicked)="onHeaderSortBtnClicked($event)">

        </app-column-header>

        <!--        last column with empty header-->
        <app-column-header
            [label]="''"
            [columnId]="'settings'"
            [showSortBtn]="0"
            class="bordered">
        </app-column-header>

    </div>



    <div class="pr-table-body" *ngIf="projects?.length">
        <app-projects-table-row *ngFor="let project of projects"
                                class="table-row"
                                [project]="project"
                                (projectRowActionsMenuClicked)="onProjectActionsMenuClicked($event)">

        </app-projects-table-row>
    </div>



    <div class="no-projects-info" *ngIf="!projects?.length">
        <img src="./assets/img/no_projects.svg" alt="icon printvolume monochrome">
        <div class="title">
            Kein Projekt vorhanden.
        </div>
        <div class="note">
            Hier können Sie neue Projekte anfragen. Unser Innendienst wird sich darum kümmern.
            Informieren Sie sich hier im Portal jederzeit über den Stand Ihres Projektes.
        </div>
    </div>
</div>
